import PropTypes from 'prop-types';

import { Card, CardContent, CardHeader } from '@mui/material';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePasswordCard = ({ args = {}, hideCard, onLogOut, isNewOrExpired }) => {
  if (hideCard) {
    return <ChangePasswordForm args={args} onLogOut={onLogOut} isNewOrExpired={isNewOrExpired} />;
  }

  return (
    <Card>
      <CardHeader title="Saisissez un mot de passe" />
      <CardContent sx={{ pt: 1 }}>
        <ChangePasswordForm args={args} onLogOut={onLogOut} isNewOrExpired={isNewOrExpired} />
      </CardContent>
    </Card>
  );
};

ChangePasswordCard.propTypes = {
  args: PropTypes.object,
  isNewOrExpired: PropTypes.bool,
  hideCard: PropTypes.bool,
  onLogOut: PropTypes.func
};

export default ChangePasswordCard;
